// NPM Modules
import { writable } from 'svelte/store';
import collect from 'collect.js';
import { mergeCollectionStore } from '@/Common/Collections.js';
// Models
import Leg from '@/Models/Leg';

/**
 * Our Store can be used 2 ways in svelte components
 * 1) ($ prefix) $StoreName to reference writable store collection with all collect.js methods available
 * 2) (Direct) StoreName.method() to call a method on the store
 */
const init = () => {
	const { subscribe, set, update } = writable(collect());

	let meta;

	const methods = {
		getPagination() {
			return meta && meta.pagination;
		},

		getLegsForMarket(marketId) {
			const leg = new Leg();

			return leg
				.sportSelections(marketId)
				.then((result) => {
					meta = result.meta;
					let allLegs = collect();
					result.data.each((leg) => {
						leg.market_id = marketId;
						allLegs.push(leg);
					});
					// set(collect(result.data));
					mergeCollectionStore(this, allLegs);
				})
				.catch((e) => {
					console.error(e);
				});
		},

		getLegsForSportscastSelection(sportscastSelectionId) {
			const leg = new Leg();

			return leg
				.sportscastSelections(sportscastSelectionId)
				.then((result) => {
					meta = result.meta;
					let allLegs = collect();
					result.data.each((leg) => {
						leg.sportscast_selection_id = sportscastSelectionId;
						allLegs.push(leg);
					});
					// set(collect(result.data));
					mergeCollectionStore(this, allLegs);
				})
				.catch((e) => {
					console.error(e);
				});
		},

		reset() {
			set(collect());
		}
	};

	return {
		subscribe,
		update,
		set,
		...methods
	};
};

export default init();
